import { z } from "zod";

export const commandStatusSchema = z.enum([
  "REQUESTED",
  "IN_PROGRESS",
  "SUCCEEDED",
  "FAILED",
]);
export type CommandStatus = z.infer<typeof commandStatusSchema>;

export const registrationCommandSchema = z.object({
  type: z.enum(["REGISTER_FOR_EVENT", "WITHDRAW_FROM_EVENT"]),
  requestedBy: z.string(),
  requestedAt: z.any(),
  eventId: z.string(),
  status: commandStatusSchema,
  error: z.string().optional(),
  // The event's door code, offered on REGISTER_FOR_EVENT when the event
  // asks for one. Absent on withdrawals and on open events.
  registrationSecret: z.string().optional(),
  payload: z.record(z.string(), z.unknown()).optional(),
});
export type RegistrationCommand = z.infer<typeof registrationCommandSchema>;
